import Service, { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { dasherize } from '@ember/string';
import { isEmpty } from '@ember/utils';
import { all, task } from 'ember-concurrency';
import { sortByProp } from 'ramda-adjunct';
import { recursiveSave } from 'eflex/util/tree-helpers';

export default class BomSourceRepoService extends Service {
  @service intl;
  @service store;

  restBomSources = this.store.peekAll('rest-bom-source');
  restPullBomSources = this.store.peekAll('rest-pull-bom-source');
  barcodeBomSources = this.store.peekAll('barcode-bom-source');
  oracleDellBoomiBomSources = this.store.peekAll('oracle-dell-boomi-bom-source');
  gepicsBomSources = this.store.peekAll('gepics-bom-source');

  get allBomSources() {
    return this.restBomSources
      .concat(this.restPullBomSources)
      .concat(this.barcodeBomSources)
      .concat(this.oracleDellBoomiBomSources)
      .concat(this.gepicsBomSources);
  }

  get sortedBomSourceOptions() {
    const options = [];

    if (!isEmpty(this.barcodeBomSources)) {
      options.push({
        groupName: this.intl.t('bomSources.barcode'),
        options: sortByProp('name', this.barcodeBomSources),
      });
    }

    if (!isEmpty(this.gepicsBomSources)) {
      options.push({
        groupName: this.intl.t('bomSources.gepics'),
        options: sortByProp('name', this.gepicsBomSources),
      });
    }

    if (!isEmpty(this.oracleDellBoomiBomSources)) {
      options.push({
        groupName: this.intl.t('bomSources.oracleDellBoomi'),
        options: sortByProp('name', this.oracleDellBoomiBomSources),
      });
    }

    if (!isEmpty(this.restBomSources)) {
      options.push({
        groupName: this.intl.t('bomSources.rest'),
        options: sortByProp('name', this.restBomSources),
      });
    }

    if (!isEmpty(this.restPullBomSources)) {
      options.push({
        groupName: this.intl.t('bomSources.restPull'),
        options: sortByProp('name', this.restPullBomSources),
      });
    }

    return options;
  }

  delete = task(waitFor(async bomSource => {
    await bomSource.destroyRecord();
  }));

  save = task(waitFor(async bomSource => {
    await bomSource.save();
    await all(bomSource.areas.map(area => recursiveSave(area)));
  }));

  create(type, properties = {}) {
    const bomSource = this.store.createRecord(dasherize(type), properties);

    const alwaysRun = this.store.createRecord('component', {
      isAlwaysRun: true,
      bomSource,
    });

    this.store.createRecord('simple-component-option', { component: alwaysRun });

    return bomSource;
  }

  peekRecord(id) {
    return this.allBomSources.find(item => item.id === id);
  }
}
